import { render, staticRenderFns } from "./DepotOpeningHoursItem.vue?vue&type=template&id=3947bac3&"
import script from "./DepotOpeningHoursItem.vue?vue&type=script&lang=js&"
export * from "./DepotOpeningHoursItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports